export const GET_ROLL_NO_REQUEST = 'GET_ROLL_NO_REQUEST';
export const GET_ROLL_NO_SUCCESS = 'GET_ROLL_NO_SUCCESS';
export const GET_ROLL_NO_FAILURE = 'GET_ROLL_NO_FAILURE';


export const CREATE_ROLL_NO_REQUEST = 'CREATE_ROLL_NO_REQUEST';
export const CREATE_ROLL_NO_SUCCESS = 'CREATE_ROLL_NO_SUCCESS';
export const CREATE_ROLL_NO_FAILURE = 'CREATE_ROLL_NO_FAILURE';